<template>
  <div>
    <base-header type="gradient-primary" class="pb-6 pb-8 pt-8 pt-md-5">
      <!-- Card stats -->
      <config-cards></config-cards>
    </base-header>

    <div class="container-fluid mt--7">
<div class="row">
        <div class="col">
          <services-table :title="$route.name === 'serviceList' ? 'Services list' : 'Live-in care plans list'"></services-table>
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ConfigCards from "@/views/System/Settings/ConfigCards"
import ServicesTable from "@/views/Tables/ServicesTable.vue"
export default {
  name: "Services",
  components: {ServicesTable, ConfigCards},
  data() {
    return {
    }
  },
  async mounted() {
  },
  methods: {
  }
}
</script>
<style></style>
